/** @deprecated */
export class SitemapRouteFlatNode {
  name!: string;
  level!: number;
  expandable!: boolean;
  isLocked!: boolean;
  isValid!: boolean;
  dashboardId: string;
  public: false;
  uuid: string;
}
